module.exports = __webpack_public_path__ + "img/icon-component-label_ImageSudoku.f2338ec0.svg";